module.exports = __webpack_public_path__ + "static/media/carottes.0a23b2ff.svg";